import React from "react";
import { Link } from "react-router-dom";
import './SideBar.css'

const SideBar = () => {
  return (
    <div
      className="bg-light m-3 p-3 mt-4 shadow rounded align-middle"
      style={{ height: "250px" }}
    >
      <div className=" align-items-center sidebar-design">
        <Link to="/manageBooks">
          <h5>Manage Books</h5>
        </Link>
        <Link to="/addBook">
          <h5>Add Books</h5>
        </Link>
        <Link to="/updateBook">
          <h5>Update Book</h5>
        </Link>
      </div>
    </div>
  );
};

export default SideBar;
